import { CIRCLE, LINE_STRING, POLYGON } from 'client/utils/constants/geometryType';

export const getFallbackCompletion = (geometryType, geometry, options = {}) => {
    const { isLineComplete } = options;

    if (geometryType === POLYGON) {
        const coordinates = geometry?.getCoordinates?.();
        const ring = Array.isArray(coordinates) && Array.isArray(coordinates[0]) ? coordinates[0] : null;
        return Array.isArray(ring) && ring.length >= 4;
    }

    if (geometryType === LINE_STRING) {
        if (typeof isLineComplete === 'function') {
            return Boolean(isLineComplete(geometry));
        }

        const coordinates = geometry?.getCoordinates?.();
        return Array.isArray(coordinates) && coordinates.length >= 2;
    }

    return geometryType === CIRCLE;
};

export const getFallbackNotifyDecision = (geometryType, complete) => {
    if (!complete) {
        return false;
    }

    return geometryType === CIRCLE || geometryType === POLYGON || geometryType === LINE_STRING;
};

export const resolveFallbackValidationFlow = (geometryType, geometry, options = {}) => {
    const complete = getFallbackCompletion(geometryType, geometry, options);
    const shouldValidateGeometry = complete || geometryType === POLYGON;

    return {
        complete,
        shouldValidateGeometry,
        shouldValidateExtent: complete,
        shouldNotify: getFallbackNotifyDecision(geometryType, complete) || (geometryType === POLYGON && shouldValidateGeometry),
        extentMessageDescriptor: undefined,
        stateNotification: null,
        policyContext: null
    };
};
